module.exports = ":host{display:block;margin-top:-10px}p{color:#d42825;font-size:1rem;font-weight:bold;line-height:21px}"